/**
 * @generated SignedSource<<cd8c5165e18869465151c22df4e529da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageSettingsLeft_page$data = {
  readonly id: string;
  readonly image: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PageSettingsDeleteButton_image">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TextControl_widgetNotePage" | "WidgetNotePageBackgroundSelector_widgetNotePage">;
  readonly " $fragmentType": "PageSettingsLeft_page";
};
export type PageSettingsLeft_page$key = {
  readonly " $data"?: PageSettingsLeft_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageSettingsLeft_page">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSettingsLeft_page",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PageSettingsDeleteButton_image"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetNotePageBackgroundSelector_widgetNotePage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TextControl_widgetNotePage"
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};
})();

(node as any).hash = "cb1db9d3c75464aaa73e572efdef467c";

export default node;
